import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";

import {OTHER_LIVE_URL} from "../../../Configurations/Urls"
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";
import { formatDate, formatTime } from "../../../Utils/DateAndTime";
import { GridClearIcon } from "@mui/x-data-grid";
import { DeleteIcon } from "lucide-react";

const nowISTString = new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
const now = new Date(nowISTString); // Now contains IST-based date & time

const inHourAndMinutes = (minutes) => {
  if (!minutes || isNaN(minutes)) return "0h 0m";

  const totalMinutes = Math.round(Number(minutes)); // round decimals
  const hrs = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;

  return `${hrs}h ${mins}m`;
};


function InternProjectTasksForm({ mode }) {

  const [SplitTask , setSplitTask] = useState(false);
  const navigate = useNavigate();
  const params = useParams(); // Get all params
  const location = useLocation();
  
  // ✅ IMPROVED: Get ID from multiple sources with better fallback
  // Try params.id first (standard React Router v6)
  let id = params?.id;
  
  // If params.id is undefined, check all param keys (for nested routes)
  if (!id && params && Object.keys(params).length > 0) {
    // Check if any param value looks like an ID (numeric)
    const paramValues = Object.values(params);
    const numericParam = paramValues.find(val => val && /^\d+$/.test(String(val)));
    if (numericParam) {
      id = numericParam;
    }
  }
  
  // If still no ID, try extracting from pathname
  if (!id && location.pathname) {
    // Match patterns like:
    // /project-task/interns/edit/123
    // /project-task/interns/edit-v2/123
    // /project-task/interns/view/123
    const pathMatch = location.pathname.match(/(?:edit|edit-v2|view)\/(\d+)/);
    if (pathMatch && pathMatch[1]) {
      id = pathMatch[1];
    }
  }
  
  // ✅ Additional fallback: Check if id is in location state
  if (!id && location.state?.id) {
    id = location.state.id;
  }
  
  // ✅ Convert to string if it's a number (for consistency)
  id = id ? String(id) : null;

  const copiedTask = location.state?.copiedTask || null;
  const { userData, reporting_manager_interns } = useAuthStore();
  const loginUserOrgPersonId = userData?.loginuser?.[0]?.organization_person_id;

  console.log("full uer data is : ", userData);
  console.log("Route params:", params);
  console.log("ID from params:", params?.id);
  console.log("ID (final):", id);
  console.log("Mode:", mode);
  console.log("Current location:", location.pathname);
  console.log("Location state:", location.state);

  const org = userData?.organization;

  const fetchProjectTasks = async () => {
    if (!id) {
      console.error("No ID provided for fetching task");
      return;
    }
    
    console.log("Fetching task with ID:", id, "Mode:", mode);
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/project-tasks/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;
      console.log("Fetched task data:", data);

      if (data) {
        const assignedPerson = data.assigned_organization_person;
        const person = assignedPerson?.person;
        const personCode = assignedPerson?.person_code;
        const assignedEmployeeDisplayName = person
          ? `${person.first_name || ""} ${person.last_name || ""}${personCode ? ` : ${personCode}` : ""}`.trim()
          : "";

        setFormData({
          organization_id: data.organization_id || "",
          organization_entity_id: data.organization_entity_id || "",
          organization_project_id: data.organization_project_id || "",
          organization_project_milestone_id: data.organization_project_milestone_id || "",
          organization_project_task_template_id: data.organization_project_task_template_id || "",
          organization_project_task_category_id: data.organization_project_task_category_id || "",
          organization_project_task_subcategory_id: data.organization_project_task_subcategory_id || "",
          organization_project_team_id: data.organization_project_team_id || "",
          priority: data.priority || "",
          task_title: data.task_title || "",
          parent_task_id: data.parent_task_id || "",
          organization_project_task_type_id: data.organization_project_task_type_id || "",
          complexity_level: data.complexity_level || "",
          quantity: data.quantity || "",
          estimated_minutes: data.estimated_minutes || "",
          assigned_employee_id: data.assigned_employee_id || "",
          assigned_date: formatDate(data.assigned_date) || "",
          assigned_time: formatTime(data.assigned_time) || "",
          status: data.status || "",
          status_remarks: data.status_remarks || "",
        });

        setAssignedEmployeeDisplayName(assignedEmployeeDisplayName);
        
        // ✅ Fetch schedules after task data is loaded (pass task-level schedule data for fallback when schedules API returns empty)
        if (id) {
          fetchTaskSchedules(id, data.assigned_employee_id, {
            scheduled_date: data.scheduled_date,
            estimated_minutes: data.estimated_minutes,
            status: data.status,
            schedules: data.schedules,
          });
        }
      }
    } catch (error) {
      toast.error("Failed to fetch project task.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if ((mode === "edit" || mode === "edit-v2" || mode == "view") && id) {
      fetchProjectTasks();
    } else if ((mode === "edit" || mode === "edit-v2" || mode == "view") && !id) {
      console.warn("Edit/View mode but no ID found. Params:", params, "Pathname:", location.pathname);
    }
  }, [mode, id, params, location.pathname]);

  const [formData, setFormData] = useState({
    organization_project_task_id:"",
    organization_id: org?.organization_id || "",
    organization_entity_id: "",
    organization_project_id: "",
    organization_project_milestone_id: "",
    organization_project_task_template_id: "",
    organization_project_task_category_id: "",
    organization_project_task_subcategory_id: "",
    organization_project_team_id: "",
    priority: "",
    task_title: "",
    parent_task_id: "",
    organization_project_task_type_id: "",
    complexity_level: "",
    quantity: "",
    estimated_minutes: "",
    assigned_employee_id: "",
    status: "",
    status_remarks: ""
  });

  const [assignedEmployeeDisplayName, setAssignedEmployeeDisplayName] = useState("");

  const [formDataSchedules, setFormDataSchedules] = useState([{
    organization_project_task_schedule_id: null,
    organization_id: org?.organization_id || "",
    organization_entity_id: null,
    organization_project_task_id: id || null,
    organization_person_id: null,
    scheduled_date: null,
    allocated_minutes: 0,
    is_reassigned: false,
    task_status: "Pending",
    status_remarks: ""
  }]);

  console.log("formDataSchedules i : ", formDataSchedules);

  const fetchTaskSchedules = async (taskId, assignedEmployeeId = null, taskLevelData = {}) => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-task-schedule`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
          organization_project_task_id: taskId
        },
      });

      console.log("Schedule response:", response);

      let made = (response.data.data || []).map(i => ({
        organization_project_task_schedule_id: i.organization_project_task_schedule_id || null,
        organization_id: i.organization_id || org?.organization_id || "",
        organization_entity_id: i.organization_entity_id || null,
        organization_project_task_id: i.organization_project_task_id || taskId || null,
        organization_person_id: i.organization_person_id || assignedEmployeeId || formData.assigned_employee_id || null,
        scheduled_date: i.scheduled_date?.split("T")[0] || null,
        allocated_minutes: i.allocated_minutes || 0,
        is_reassigned: i.is_reassigned || false,
        task_status: i.task_status || "Pending",
        status_remarks: i.status_remarks || "",
      }));
      
      // If no schedules from API, use task-level data or schedules from task API response
      if (made.length === 0) {
        const { scheduled_date, estimated_minutes, status, schedules } = taskLevelData;
        const taskSchedules = Array.isArray(schedules) && schedules.length > 0 ? schedules : null;
        
        if (taskSchedules && taskSchedules.length > 0) {
          made = taskSchedules.map(i => ({
            organization_project_task_schedule_id: i.organization_project_task_schedule_id || null,
            organization_id: i.organization_id || org?.organization_id || "",
            organization_entity_id: i.organization_entity_id || null,
            organization_project_task_id: i.organization_project_task_id || taskId || null,
            organization_person_id: i.organization_person_id || assignedEmployeeId || formData.assigned_employee_id || null,
            scheduled_date: (i.scheduled_date || "").split("T")[0] || null,
            allocated_minutes: i.allocated_minutes ?? 0,
            is_reassigned: i.is_reassigned || false,
            task_status: i.task_status || "Pending",
            status_remarks: i.status_remarks || "",
          }));
        } else {
          const taskScheduledDate = scheduled_date ? (typeof scheduled_date === "string" ? scheduled_date.split("T")[0] : scheduled_date) : null;
          made = [{
            organization_project_task_schedule_id: null,
            organization_id: org?.organization_id || "",
            organization_entity_id: null,
            organization_project_task_id: taskId || null,
            organization_person_id: assignedEmployeeId || formData.assigned_employee_id || null,
            scheduled_date: taskScheduledDate,
            allocated_minutes: Number(estimated_minutes) || 0,
            is_reassigned: false,
            task_status: status || "Pending",
            status_remarks: "",
          }];
        }
      }
      
      setFormDataSchedules(made);

      // ✅ Auto-detect split mode based on number of schedules
      //    - More than 1 schedule → treat as Split Task
      //    - 0 or 1 schedule     → normal (non-split) task
      setSplitTask(made.length > 1);
    } catch (e) {
      console.error("Failed to load task schedules:", e);
      toast.error("Failed to load task schedules");
    }
  };


  // Schedules are now fetched inside fetchProjectTasks after task data loads


  console.log("vsi : ", copiedTask);
  useEffect(() => {

    if (copiedTask && mode === "add") {

      // Remove assigned fields
      const { assigned_date, assigned_time, schedules, ...rest } = copiedTask;

      // Apply everything except assigned_date/time
      setFormData(prev => ({
        ...prev,
        ...rest,
      }));

      setFormDataSchedules(schedules);

      // ✅ If copied task has multiple schedules, enable Split Task by default
      setSplitTask(Array.isArray(schedules) && schedules.length > 1);
    }

  }, [copiedTask, mode]);

  const [formErrors, setFormErrors] = useState({});
  const [scheduleFormErrors, setScheduleFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {
    const errors = {};
    const now = new Date();

    const dateFields = ["assigned_date"];
    const timeFields = ["assigned_time"];
    const numberFields = ["quantity", "estimated_minutes"];

    // Basic required validations
    if (!formData.organization_project_id)
      errors.organization_project_id = "Project is required";

    if (!formData.organization_project_task_category_id)
      errors.organization_project_task_category_id =
        "Project Task Category is required";

    if (!formData.task_title?.trim())
      errors.task_title = "Task Title is required";

    if (!formData.organization_project_task_template_id)
      errors.organization_project_task_template_id = "Task Template is required";

    if (formData.task_title?.length > 150)
      errors.task_title = "Max 150 characters";

    if (formData.task_short_name?.trim()?.length > 20)
      errors.task_short_name = "Max 20 characters";

    if (!formData.priority)
      errors.priority = "Project Task Priority is required";

    if (
      formData.complexity_level &&
      !["Low", "Medium", "High", "Expert"].includes(formData.complexity_level)
    ) {
      errors.complexity_level = "Invalid Complexity";
    }

    if (
      formData.status &&
      ![
        "Pending",
        "In Progress",
        "In Review",
        "Approved",
        "Rejected",
        "Completed",
        "Blocked",
      ].includes(formData.status)
    ) {
      errors.status = "Invalid Status";
    }

    // Basic number validation
    numberFields.forEach((field) => {
      const val = formData[field];

      if (val !== "" && val !== null && val !== undefined) {
        if (isNaN(val) || parseFloat(val) < 0) {
          errors[field] = "Enter a valid number";
        }
      }
    });

    // 🚀 Special validation for estimated_minutes (decimal minutes < 60)
    if (formData.estimated_minutes) {
      const val = formData.estimated_minutes.toString();

      // Must be number with optional decimals, max 2 digits
      if (!/^\d+(\.\d{1,2})?$/.test(val)) {
        errors.estimated_minutes = "Invalid format (max 2 decimal places)";
      } else {
        const [hrs, mins] = val.split(".");
        if (mins && parseInt(mins) >= 60) {
          errors.estimated_minutes =
            "Seconds after decimal must be less than 60";
        }
      }
    }

    // Date validation
    dateFields.forEach((field) => {
      const val = formData[field];
      if (val && isNaN(Date.parse(val))) {
        errors[field] = "Invalid date";
      }
    });

    // Time validation (HH:MM format)
    timeFields.forEach((field) => {
      const val = formData[field];
      if (val && !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(val)) {
        errors[field] = "Invalid time (HH:MM)";
      }
    });


    /** =====================================================
     *  ⭐ NEW VALIDATION #1 — CHECK FOR DEFAULT SCHEDULE VALUES
     * ===================================================== */
    const scheduleErrors = {};

    formDataSchedules.forEach((item, index) => {
      if (
        item.scheduled_date === null ||
        item.allocated_minutes === 0 ||
        item.allocated_minutes === null
      ) {
        scheduleErrors[index] = {
          ...scheduleErrors[index],
          rowError: "Scheduled Date and Allocated Minutes are required in schedule row",
        };
      }
    });

    /** =====================================================
     * ⭐ PREVENT DUPLICATE SCHEDULE DATES (FIXED VERSION)
     * ===================================================== */

    const dateMap = {};

    formDataSchedules.forEach((item, index) => {
      if (!item.scheduled_date) return;

      if (dateMap[item.scheduled_date] !== undefined) {
        const firstIndex = dateMap[item.scheduled_date];

        scheduleErrors[index] = {
          ...scheduleErrors[index],
          scheduled_date: "Duplicate scheduled date not allowed",
        };

        scheduleErrors[firstIndex] = {
          ...scheduleErrors[firstIndex],
          scheduled_date: "Duplicate scheduled date not allowed",
        };
      } else {
        dateMap[item.scheduled_date] = index;
      }
    });

    /** =====================================================
     * ⭐ NEW VALIDATION #2 — TOTAL ALLOCATED MINUTES CHECK
     * ===================================================== */

    const totalAllocated = formDataSchedules.reduce(
      (sum, item) => sum + (parseFloat(item.allocated_minutes) || 0),
      0
    );

    const expectedTotal = (parseFloat(formData.estimated_minutes) || 0) *
      (parseInt(formData.quantity) || 0);

    if (expectedTotal !== 0 && totalAllocated !== expectedTotal) {
      const lastIndex = formDataSchedules.length - 1;

      scheduleErrors[lastIndex] = {
        ...scheduleErrors[lastIndex],
        allocated_minutes: `Total allocated minutes (${totalAllocated}) must equal Estimated Minutes × Quantity (${expectedTotal})`,
      };
    }

    setScheduleFormErrors(scheduleErrors);

    /** -------------------------
     * FINAL SET ERROR STATE
     * ------------------------- */
    setFormErrors(errors);

    return Object.keys(errors).length === 0 && Object.keys(scheduleErrors).length === 0;

  };


  const [selectOptions, setSelectOptions] = useState({
    Project: [],
    TaskTemplates: [],
    ParentTasks: [],
    ProjectMileStones: [],
    Recurrences: [],
    Employees: [],
    TaskTypes: [],
    Categories: [],
    SubCategories: [],
    Teams: [],
    TeamMembers: [],
  })

  const fetchProjects = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/projects`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

         const sortedProjects = [...response.data.data].sort((a, b) =>
        (a.project_name || "").localeCompare(b.project_name || "")
      );


      setSelectOptions((prev) => ({ ...prev, Project: sortedProjects }));
    } catch (e) {
      console.error("Failed to load projects");
    }
  };



  const fetchTaskTemplates = async () => {

    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-task-template`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      setSelectOptions((prev) => ({ ...prev, TaskTemplates: response.data.data }));
    } catch (e) {
      console.error("Failed to load task templates");
    }
  };

  const fetchRecurrences = async () => {

    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-task-recurrence`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      setSelectOptions((prev) => ({ ...prev, Recurrences: response.data.data }));
    } catch (e) {
      console.error("Failed to load task recurrences");
    }
  };

  const fetchEmployeesOfOrg = async () => {
    try {
     // const response = await axios.get(`${MAIN_URL}/api/organizations/employees?type=Intern`, {
      const response = await axios.get(`${OTHER_LIVE_URL}/api/organizations/${org.organization_id}/persons-data-all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
       
      });

      // Filter only interns (person_type_id = 2) - show all org interns for reporting managers
      let internsOnly = (response.data.persons || []).filter(
        (person) => person.organization_person?.person_type_id === 2
      );
      const sortedEmps = [...internsOnly].sort((a, b) =>
        (`${a.first_name} ${a.last_name} - ${a.organization_person?.person_code}` || "").localeCompare(`${b.first_name} ${b.last_name} - ${b.organization_person?.person_code}` || "")
      );
      setSelectOptions((prev) => ({ ...prev, Employees: sortedEmps }));
    } catch (e) {
      console.error("Failed to load Employees");
    }
  };

  const fetchParentTasks = async () => {

    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-tasks`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      const sortedTasks = [...response.data.data].sort((a, b) =>
        (a.task_title || "").localeCompare(b.task_title || "")
      );

      if (mode == "add") {
        setSelectOptions((prev) => ({ ...prev, ParentTasks: sortedTasks }));
      } else {

        let Tasks = sortedTasks.filter(item => item.organization_project_task_id != id)

        setSelectOptions((prev) => ({ ...prev, ParentTasks: Tasks }));
      }
    } catch (e) {
      console.error("Failed to load project tasks");
    }
  };

  const fetchTaskTypes = async () => {

    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-task-type`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });


      setSelectOptions((prev) => ({ ...prev, TaskTypes: response.data.data }));

    } catch (e) {
      console.error("Failed to load project task type");
    }
  };

  const fetchTeams = async () => {

    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-teams`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });


      setSelectOptions((prev) => ({ ...prev, Teams: response.data.data }));

    } catch (e) {
      console.error("Failed to load project teams");
    }
  };

  const fetchTeamMembers = async (team_id) => {

    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-team-members`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
          team_id: team_id
        },
      });


      setSelectOptions((prev) => ({ ...prev, TeamMembers: response.data.data }));

    } catch (e) {
      console.error("Failed to load project task type");
    }
  };


  const fetchProjectTaskCategories = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-task-category`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      console.log("response Categories is : ", response);

      setSelectOptions((prev) => ({ ...prev, Categories: response.data.data }));
    } catch (e) {
      console.error("Failed to load Categories");
    }
  };

  const fetchProjectTaskSubCategories = async (category_id) => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-task-sub-category`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
          category_id
        },
      });

      console.log("response SubCategories is : ", response);

      setSelectOptions((prev) => ({ ...prev, SubCategories: response.data.data }));
    } catch (e) {
      console.error("Failed to load SubCategories");
    }
  };

  useEffect(() => {
    fetchProjects();
    fetchTaskTemplates();
    fetchParentTasks();
    fetchRecurrences();
    fetchEmployeesOfOrg();
    fetchTaskTypes();
    fetchProjectTaskCategories();
    fetchTeams();
  }, [org?.organization_id]);


  useEffect(() => {
    if (formData?.organization_project_task_category_id) {
      fetchProjectTaskSubCategories(formData?.organization_project_task_category_id);
    }
  }, [formData?.organization_project_task_category_id]);

  useEffect(() => {
    if (formData?.organization_project_team_id) {
      fetchTeamMembers(formData?.organization_project_team_id);
    }
  }, [formData?.organization_project_team_id]);

  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    const cleanData = { ...formData };

    // Convert empty strings to null for nullable fields
    Object.keys(cleanData).forEach((key) => {
      if (cleanData[key] === "") {
        cleanData[key] = null;
      }
    });

    // Convert numeric fields
    ["parent_task_id", "quantity", "organization_entity_id", "organization_project_task_template_id", "organization_project_task_type_id", "organization_project_milestone_id", "assigned_employee_id"].forEach(key => {
      if (cleanData[key] !== null && cleanData[key] !== undefined && cleanData[key] !== "") {
        cleanData[key] = parseInt(cleanData[key], 10);
      }
    });

    // Append is_backlog boolean explicitly
    cleanData.is_backlog = !!cleanData.is_backlog;

    // Debug: Log assigned_employee_id to ensure it's being sent
    console.log("Sending assigned_employee_id:", cleanData.assigned_employee_id);

    const normalizeTime = (timeStr) => {
      if (!timeStr) return null;
      return timeStr.length === 5 ? `${timeStr}:00` : timeStr;
    };

    ["assigned_time", "started_time", "ended_time", "approved_time"].forEach((key) => {
      if (cleanData[key]) {
        cleanData[key] = normalizeTime(cleanData[key]);
      }
    });


    let organization_entity_id = userData?.organization?.
      entities?.organization_entity_id || null;
    console.log("organization_entity_id is : ", organization_entity_id);

    // ✅ Prepare schedules with organization_person_id from assigned_employee_id
    const preparedSchedules = formDataSchedules.map(schedule => ({
      ...schedule,
      organization_person_id: cleanData.assigned_employee_id || schedule.organization_person_id,
      // Ensure numeric fields are numbers
      allocated_minutes: Number(schedule.allocated_minutes) || 0,
      is_reassigned: schedule.is_reassigned || false,
      task_status: schedule.task_status || "Pending",
      status_remarks: schedule.status_remarks || "",
    }));

    console.log("Prepared schedules:", preparedSchedules);
    console.log("Form data:", cleanData);

    setBtnLoading(true);
    try {
      const token = localStorage.getItem("token");

      if (mode === "edit" || mode === "edit-v2") {
        await axios.put(`${MAIN_URL}/api/project-management/project-tasks/update-v1/${id}`, { 
          ...cleanData, 
          organization_entity_id, 
          organization_id: org?.organization_id, 
          schedules: preparedSchedules 
        }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Intern Project Task updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/project-tasks/store-v1`, { 
          ...cleanData, 
          organization_entity_id, 
          organization_id: org?.organization_id, 
          schedules: preparedSchedules 
        }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Intern Project Task added");
      }

      navigate("/project-task/interns");
    } catch (err) {
      if (err.response?.status === 422) {
        toast.error("Please fix the validation errors.");
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };

  const buildTaskTitle = (categoryId, subCategoryId, customTitle) => {
    const category = selectOptions.Categories.find(
      c => c.organization_project_task_category_id == categoryId
    );
    const subCategory = selectOptions.SubCategories.find(
      s => s.organization_project_task_subcategory_id == subCategoryId
    );

    return [
      category?.task_category_name,
      subCategory?.task_subcategory_name,
      customTitle
    ].filter(Boolean).join(" - ");
  };


  // Handle input changes
  const handleChange = (e) => {

    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));

    // -------- Category changes --------
    if (name === "organization_project_task_category_id") {
      const finalTitle = buildTaskTitle(
        value,
        formData.organization_project_task_subcategory_id,
        formData.task_title
      );

      setFormData(prev => ({
        ...prev,
        task_title: finalTitle
      }));
    }

    // -------- SubCategory changes --------
    if (name === "organization_project_task_subcategory_id") {
      const finalTitle = buildTaskTitle(
        formData.organization_project_task_category_id,
        value,
        formData.task_title
      );

      setFormData(prev => ({
        ...prev,
        task_title: finalTitle
      }));
    }

    // -------- User typing in title --------
    if (name === "task_title") {
      const category = selectOptions.Categories.find(
        c => c.organization_project_task_category_id == formData.organization_project_task_category_id
      );
      const subCategory = selectOptions.SubCategories.find(
        s => s.organization_project_task_subcategory_id == formData.organization_project_task_subcategory_id
      );

      const catName = category ? category.task_category_name : "";
      const subCatName = subCategory ? subCategory.task_subcategory_name : "";

      const prefix = [catName, subCatName].filter(Boolean).join(" - ");

      const requiredPrefix = prefix ? prefix + " - " : "";

      let userTyped = value;

      // If user tries to delete or change prefix → restore prefix
      if (!userTyped.startsWith(requiredPrefix)) {
        userTyped = requiredPrefix + userTyped.replace(requiredPrefix, "");
      }

      // Update ONLY the user-editable suffix
      setFormData(prev => ({
        ...prev,
        task_title: userTyped
      }));

      return;
    }

    if (name == 'organization_project_id') {

      setFormData((prev) => ({ ...prev, ["organization_project_milestone_id"]: null }));
      setFormErrors((prev) => ({ ...prev, ["organization_project_milestone_id"]: "" }));

      let filteredTemplate = selectOptions?.Project?.filter(item => item.organization_project_id == value);

      if (filteredTemplate.length > 0) {
        setSelectOptions((prev) => ({ ...prev, ProjectMileStones: filteredTemplate[0].milestone }));
      }

    }

    if (name == 'organization_project_task_template_id') {

      let filteredTemplate = selectOptions?.TaskTemplates?.filter(item => item.organization_project_task_template_id == value);

      if (filteredTemplate.length > 0) {

        setFormData((prev) => (
          {
            ...prev,
            task_title: filteredTemplate?.[0]?.task_title,
            estimated_minutes: filteredTemplate?.[0]?.estimated_minutes,
            organization_project_task_category_id: filteredTemplate?.[0]?.organization_project_task_category_id,
            organization_project_task_subcategory_id: filteredTemplate?.[0]?.organization_project_task_subcategory_id,
            complexity_level: filteredTemplate?.[0]?.complexity_level,
          }));

        setFormErrors((prev) => ({
          ...prev,
          task_title: "",
          estimated_minutes: "",
          organization_project_task_category_id: "",
          organization_project_task_subcategory_id: "",
          complexity_level: ""
        }));

      }
    }

    if (name == "organization_project_team_id") {
      setFormData((prev) => ({ ...prev, ["assigned_employee_id"]: "" }));
      setFormErrors((prev) => ({ ...prev, ["assigned_employee_id"]: "" }));

    }

  };

  console.log("formdata is : ", formData);

  const teamMemberIds = selectOptions?.TeamMembers?.map(m => m.organization_person_id) || [];

  const viewModeAssignedEmployeeName = React.useMemo(() => {
    if (assignedEmployeeDisplayName) return assignedEmployeeDisplayName;
    const idVal = formData.assigned_employee_id;
    if (!idVal) return "—";
    const emp = selectOptions?.Employees?.find(
      (e) => (e.organization_person_id || e.organization_person?.organization_person_id) == idVal
    );
    if (!emp) return "—";
    return `${emp.first_name || ""} ${emp.last_name || ""} : ${emp.organization_person?.person_code || ""}`.trim();
  }, [assignedEmployeeDisplayName, formData.assigned_employee_id, selectOptions?.Employees]);

  const filterProjects = (options, { inputValue }) => {
    const query = (inputValue || "").trim().toLowerCase();
    if (query.length < 2) return [];

    const filtered = [];
    for (const project of options) {
      const label = (project.project_name || "").toLowerCase().trim();
      if (label.includes(query)) {
        filtered.push(project);
      }
      if (filtered.length >= 50) break;
    }
    return filtered;
  };

  const filterTaskTemplates = (options, { inputValue }) => {
    const query = (inputValue || "").trim().toLowerCase();
    if (query.length < 2) return [];

    const filtered = [];
    for (const tpl of options) {
      const label = (tpl.task_title || "").toLowerCase().trim();
      if (label.includes(query)) {
        filtered.push(tpl);
      }
      if (filtered.length >= 50) break;
    }
    return filtered;
  };

  const filterParentTasks = (options, { inputValue }) => {
    const query = (inputValue || "").trim().toLowerCase();
    if (query.length < 2) return [];

    const filtered = [];
    for (const task of options) {
      const label = (task.task_title || "").toLowerCase().trim();
      if (label.includes(query)) {
        filtered.push(task);
      }
      if (filtered.length >= 50) break;
    }
    return filtered;
  };

  const filterEmployees = (options, { inputValue }) => {
    const query = (inputValue || "").trim().toLowerCase();
    if (query.length < 2) return [];

    const filtered = [];
    for (const emp of options) {
      const label = `${emp.first_name || ""} ${emp.last_name || ""} ${emp.organization_person?.person_code || ""}`
        .toLowerCase()
        .trim();

      if (label.includes(query)) {
        filtered.push(emp);
      }
      if (filtered.length >= 50) break;
    }
    return filtered;
  };

  useEffect(() => {
    if (!SplitTask && formDataSchedules.length === 1) {
      const totalMinutes = (Number(formData.estimated_minutes) || 0) * (Number(formData.quantity) || 1);
      
      // Only update if the value actually changed to prevent infinite loops
      if (formDataSchedules[0].allocated_minutes !== totalMinutes) {
        setFormDataSchedules(prev => [{
          ...prev[0],
          allocated_minutes: totalMinutes
        }]);
      }
    }
  }, [formData.estimated_minutes, formData.quantity, SplitTask, formDataSchedules.length]);

  return (
    <Box px={4} py={4}>

      <Header
        pasteCode={"pro-task"}
        onClickPaste={(pasteData) =>
          setFormData((prev) => ({
            ...prev,
            ...pasteData,
            assigned_date: prev.assigned_date, // keep original IST date
            assigned_time: prev.assigned_time, // keep original IST time
            scheduled_date: prev.assigned_date, // keep original IST date
          }))
        }

        mode={mode}
        updateMessage={"Intern Project Tasks"}
        addMessage={"Intern Project Tasks"}
        homeLink={(mode == "view" || mode == "edit-v2") ? "/" : "/project-task/interns"}
        homeText={(mode == "view" || mode == "edit-v2") ? "Dashboard" : "Intern Project Task"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>

                <Autocomplete
                  disabled={mode == "view"}
                  fullWidth
                  filterOptions={filterProjects}
                  options={selectOptions?.Project || []}
                  getOptionLabel={(option) => option?.project_name || ""}
                  value={
                    selectOptions?.Project?.find(
                      (project) =>
                        project.organization_project_id == formData.organization_project_id
                    ) || null
                  }
                  onChange={(_, newValue) =>
                    handleChange({
                      target: {
                        name: "organization_project_id",
                        value: newValue ? newValue.organization_project_id : "",
                      },
                    })
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.organization_project_id === value.organization_project_id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Project *"
                      error={!!formErrors.organization_project_id}
                      helperText={formErrors.organization_project_id}
                    />
                  )}
                />

                <Autocomplete
                  fullWidth
                  disabled={mode == "view" || selectOptions.ProjectMileStones.length == 0}
                  options={selectOptions?.ProjectMileStones || []}
                  getOptionLabel={(option) => option?.milestone_title || ""}
                  value={
                    selectOptions?.ProjectMileStones?.find(
                      (milestone) =>
                        milestone.organization_project_milestone_id ==
                        formData.organization_project_milestone_id
                    ) || null
                  }
                  onChange={(_, newValue) =>
                    handleChange({
                      target: {
                        name: "organization_project_milestone_id",
                        value: newValue ? newValue.organization_project_milestone_id : "",
                      },
                    })
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.organization_project_milestone_id ===
                    value.organization_project_milestone_id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Project MileStone"
                      error={!!formErrors.organization_project_milestone_id}
                      helperText={formErrors.organization_project_milestone_id}
                    />
                  )}
                />

                <Autocomplete
                  fullWidth
                  disabled={mode == "view"}
                  options={selectOptions.Categories || []}
                  getOptionLabel={(option) => option?.task_category_name || ""}
                  value={
                    selectOptions.Categories.find(
                      (cat) =>
                        cat.organization_project_task_category_id ==
                        formData.organization_project_task_category_id
                    ) || null
                  }
                  onChange={(_, newValue) =>
                    handleChange({
                      target: {
                        name: "organization_project_task_category_id",
                        value: newValue ? newValue.organization_project_task_category_id : "",
                      },
                    })
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.organization_project_task_category_id ===
                    value.organization_project_task_category_id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Project Task Category *"
                      error={!!formErrors.organization_project_task_category_id}
                      helperText={formErrors.organization_project_task_category_id}
                    />
                  )}
                />

                <Autocomplete
                  fullWidth
                  disabled={selectOptions.SubCategories.length == 0 || mode == "view"}
                  options={selectOptions.SubCategories || []}
                  getOptionLabel={(option) => option?.task_subcategory_name || ""}
                  value={
                    selectOptions.SubCategories.find(
                      (cat) =>
                        cat.organization_project_task_subcategory_id ==
                        formData.organization_project_task_subcategory_id
                    ) || null
                  }
                  onChange={(_, newValue) =>
                    handleChange({
                      target: {
                        name: "organization_project_task_subcategory_id",
                        value: newValue ? newValue.organization_project_task_subcategory_id : "",
                      },
                    })
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.organization_project_task_subcategory_id ===
                    value.organization_project_task_subcategory_id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Project Task Sub Category"
                      error={!!formErrors.organization_project_task_subcategory_id}
                      helperText={
                        selectOptions.Categories.length == 0
                          ? "No SubCategories Available For This Category"
                          : formErrors.organization_project_task_subcategory_id
                      }
                    />
                  )}
                />

                <Autocomplete
                  fullWidth
                  disabled={mode == "view"}
                  filterOptions={filterTaskTemplates}
                  options={selectOptions?.TaskTemplates || []}
                  getOptionLabel={(option) => option?.task_title || ""}
                  value={
                    selectOptions?.TaskTemplates?.find(
                      (template) =>
                        template.organization_project_task_template_id ==
                        formData.organization_project_task_template_id
                    ) || null
                  }
                  onChange={(_, newValue) =>
                    handleChange({
                      target: {
                        name: "organization_project_task_template_id",
                        value: newValue ? newValue.organization_project_task_template_id : "",
                      },
                    })
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.organization_project_task_template_id ===
                    value.organization_project_task_template_id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Task Template *"
                      error={!!formErrors.organization_project_task_template_id}
                      helperText={formErrors.organization_project_task_template_id}
                    />
                  )}
                />

                <Autocomplete
                  fullWidth
                  disabled={mode == "view"}
                  options={['Low', 'Medium', 'High', 'Critical']}
                  getOptionLabel={(option) => option}
                  value={formData.priority || null}
                  onChange={(_, newValue) =>
                    handleChange({
                      target: {
                        name: "priority",
                        value: newValue || "",
                      },
                    })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Priority *"
                      error={!!formErrors.priority}
                      helperText={formErrors.priority}
                    />
                  )}
                />

                <TextField
                  disabled={mode === "view"}
                  fullWidth
                  label="Task Title *"
                  name="task_title"
                  value={formData.task_title}
                  onChange={handleChange}
                  error={!!formErrors.task_title}
                  helperText={formErrors.task_title}
                />

                <Autocomplete
                  fullWidth
                  disabled={mode == "view"}
                  filterOptions={filterParentTasks}
                  options={selectOptions?.ParentTasks || []}
                  getOptionLabel={(option) => option?.task_title || ""}
                  value={
                    selectOptions?.ParentTasks?.find(
                      (project) =>
                        project.organization_project_task_id == formData.parent_task_id
                    ) || null
                  }
                  onChange={(_, newValue) =>
                    handleChange({
                      target: {
                        name: "parent_task_id",
                        value: newValue ? newValue.organization_project_task_id : "",
                      },
                    })
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.organization_project_task_id === value.organization_project_task_id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Parent Task"
                      error={!!formErrors.parent_task_id}
                      helperText={formErrors.parent_task_id}
                    />
                  )}
                />

                <Autocomplete
                  fullWidth
                  disabled={mode == "view"}
                  options={selectOptions?.TaskTypes || []}
                  getOptionLabel={(option) => option?.task_type_name || ""}
                  value={
                    selectOptions?.TaskTypes?.find(
                      (taskType) =>
                        taskType.organization_project_task_type_id ==
                        formData.organization_project_task_type_id
                    ) || null
                  }
                  onChange={(_, newValue) =>
                    handleChange({
                      target: {
                        name: "organization_project_task_type_id",
                        value: newValue ? newValue.organization_project_task_type_id : "",
                      },
                    })
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.organization_project_task_type_id ===
                    value.organization_project_task_type_id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Task Type"
                      error={!!formErrors.organization_project_task_type_id}
                      helperText={formErrors.organization_project_task_type_id}
                    />
                  )}
                />

                <Autocomplete
                  fullWidth
                  disabled={mode == "view"}
                  options={['Low', 'Medium', 'High', 'Expert']}
                  getOptionLabel={(option) => option}
                  value={formData.complexity_level || null}
                  onChange={(_, newValue) =>
                    handleChange({
                      target: {
                        name: "complexity_level",
                        value: newValue || "",
                      },
                    })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Complexity"
                      error={!!formErrors.complexity_level}
                      helperText={formErrors.complexity_level}
                    />
                  )}
                />

                <TextField
                  fullWidth

                  disabled={
                    mode === "view" ||
                    (
                      formData.organization_project_task_template_id !== "" &&
                      formData.organization_project_task_template_id !== null
                    )
                  }
                  label="Allocated Minutes"
                  name="estimated_minutes"
                  type="number"
                  value={formData.estimated_minutes}
                  onChange={handleChange}
                  error={!!formErrors.estimated_minutes}
                  helperText={formErrors.estimated_minutes}
                />

                <TextField
                  fullWidth
                  disabled={mode == "view"}
                  label="Quantity "
                  name="quantity"
                  type="number"
                  value={formData.quantity}
                  onChange={handleChange}
                  error={!!formErrors.quantity}
                  helperText={formErrors.quantity}
                />

                <TextField
                  disabled={true}
                  fullWidth
                  label="Total Allocated Minutes "
                  name="total_estimated_minutes"
                  type="text"
                  value={`${(formData.estimated_minutes * formData.quantity)} (${inHourAndMinutes(formData.estimated_minutes * formData.quantity)})`}
                  helperText="Self Calculated"
                  InputLabelProps={{ shrink: true }} // <-- forces the label to stay up
                />

                <Autocomplete
                  fullWidth
                  disabled={mode == "view"}
                  options={selectOptions.Teams || []}
                  getOptionLabel={(option) => option?.project_team_name || ""}
                  value={
                    selectOptions.Teams?.find(
                      (team) =>
                        team.organization_project_team_id ==
                        formData.organization_project_team_id
                    ) || null
                  }
                  onChange={(_, newValue) =>
                    handleChange({
                      target: {
                        name: "organization_project_team_id",
                        value: newValue ? newValue.organization_project_team_id : "",
                      },
                    })
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.organization_project_team_id ===
                    value.organization_project_team_id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Team"
                      error={!!formErrors.organization_project_team_id}
                      helperText={formErrors.organization_project_team_id}
                    />
                  )}
                />

                {mode === "view" ? (
                  <TextField
                    fullWidth
                    disabled
                    label="Assigned To Intern"
                    value={viewModeAssignedEmployeeName}
                  />
                ) : (
                  <Autocomplete
                    fullWidth
                    disabled={mode == "view"}
                    filterOptions={filterEmployees}
                    options={
                      selectOptions?.Employees || []
                    }
                    getOptionLabel={(emp) =>
                      emp
                        ? `${emp.first_name || ""} ${emp.last_name || ""} : ${
                            emp.organization_person?.person_code || ""
                          }`.trim()
                        : ""
                    }
                    value={
                      selectOptions?.Employees?.find(
                        (e) =>
                          (e.organization_person_id ||
                            e.organization_person?.organization_person_id) ==
                          (formData.assigned_employee_id ?? "")
                      ) || null
                    }
                    onChange={(_, newValue) =>
                      handleChange({
                        target: {
                          name: "assigned_employee_id",
                          value: newValue
                            ? newValue.organization_person_id ||
                              newValue.organization_person
                                ?.organization_person_id
                            : "",
                        },
                      })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Assigned To Intern"
                        error={!!formErrors.assigned_employee_id}
                        helperText={formErrors.assigned_employee_id}
                      />
                    )}
                  />
                )}

                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={mode=="view"}
                      checked={SplitTask}
                      onChange={() => {
                        const nextSplitState = !SplitTask;
                        setSplitTask(nextSplitState);

                        if (nextSplitState) {
                          // Switching TO Split mode: add a second empty row
                          setFormDataSchedules([
                            ...formDataSchedules,
                            {
                              organization_project_task_schedule_id: null,
                              organization_id: formData.organization_id || "",
                              organization_entity_id: null,
                              organization_project_task_id: id || null,
                              organization_person_id: formData.assigned_employee_id || null,
                              scheduled_date: null,
                              allocated_minutes: 0,
                              is_reassigned: false,
                              task_status: "Pending",
                              status_remarks: ""
                            }
                          ]);
                        } else {
                          // Switching OFF Split mode: Keep only first row and set to total
                          const totalMinutes = (Number(formData.estimated_minutes) || 0) * (Number(formData.quantity) || 1);
                          setFormDataSchedules([{
                            ...formDataSchedules[0],
                            allocated_minutes: totalMinutes
                          }]);
                        }
                      }}
                    />
                  }
                  label="Split Task"
                />

                {/* {[
                  ['assigned', 'Assigned'],
                ].map(([key, label]) => (
                  <React.Fragment key={key}>
                    <TextField
                      disabled={mode == "view"}
                      fullWidth
                      label={`${label} Date `}
                      name={`${key}_date`}
                      type="date"

                      InputLabelProps={{ shrink: true }}
                      value={formData[`${key}_date`]}
                      onChange={handleChange}
                      error={!!formErrors[`${key}_date`]}
                      helperText={formErrors[`${key}_date`]}
                    />
                    <TextField
                      disabled={mode == "view"}
                      fullWidth
                      label={`${label} Time `}
                      name={`${key}_time`}
                      type="time"
                      InputLabelProps={{ shrink: true }}
                      value={formData[`${key}_time`]}
                      onChange={handleChange}
                      error={!!formErrors[`${key}_time`]}
                      helperText={formErrors[`${key}_time`]}
                    />
                  </React.Fragment>
                ))} */}

                {/* ---------------------- TASK SCHEDULES UI ---------------------- */}
                <div style={{ width: "100%" }}>
                  <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 600 }}>
                    Task Schedules
                  </Typography>

                  {formDataSchedules?.map((schedule, index) => (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%", marginBottom: "30px" }}>
                      <TextField
                        disabled={mode === "view"}
                        fullWidth
                        type="date"
                        label="Scheduled Date"
                        InputLabelProps={{ shrink: true }}
                        value={schedule.scheduled_date || ""}
                        error={!!scheduleFormErrors[index]?.scheduled_date}
                        helperText={scheduleFormErrors[index]?.scheduled_date}
                        onChange={(e) => {
                          const newArr = [...formDataSchedules];
                          newArr[index].scheduled_date = e.target.value;
                          setFormDataSchedules(newArr);
                        }}
                      />

                      <TextField
                        disabled={mode === "view" || !SplitTask}
                        fullWidth
                        type="number"
                        label="Allocated Minutes"
                        value={
                          !SplitTask
                            ? (Number(formData.estimated_minutes) * Number(formData.quantity))
                            : schedule.allocated_minutes
                        }
                        error={!!scheduleFormErrors[index]?.allocated_minutes}
                        helperText={scheduleFormErrors[index]?.allocated_minutes}
                        onChange={(e) => {
                          const newArr = [...formDataSchedules];
                          newArr[index].allocated_minutes = Number(e.target.value);
                          setFormDataSchedules(newArr);
                        }}
                      />

                      <Autocomplete
                        fullWidth
                        disabled={mode === "view"}
                        options={[
                          "Pending",
                          "Paused",
                          "In Progress",
                          "In Review",
                          "Approved",
                          "Rejected",
                          "Completed",
                          "Blocked",
                        ]}
                        getOptionLabel={(option) => option}
                        value={schedule.task_status || "Pending"}
                        onChange={(_, newValue) => {
                          const newArr = [...formDataSchedules];
                          newArr[index].task_status = newValue || "Pending";
                          setFormDataSchedules(newArr);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Status"
                          />
                        )}
                      />

                      {mode !== "view" && SplitTask===true && formDataSchedules.length > 2 && (
                        <IconButton
                          color="error"
                          sx={{ mt: "6px" }}
                          onClick={() => {
                            const newArr = formDataSchedules.filter((_, i) => i !== index);
                            setFormDataSchedules(newArr);
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}

                      {scheduleFormErrors[index]?.rowError && (
                        <Grid item xs={12}>
                          <Typography color="error" fontSize="14px">
                            {scheduleFormErrors[index].rowError}
                          </Typography>
                        </Grid>
                      )}

                    </div>

                  ))}
                  {mode !== "view"&& SplitTask === true && (
                    <Button
                      variant="contained"
                      sx={{ mt: 1 }}
                      onClick={() =>
                        setFormDataSchedules([
                          ...formDataSchedules,
                          {
                            organization_project_task_schedule_id: null,
                            organization_id: org?.organization_id || "",
                            organization_entity_id: null,
                            organization_project_task_id: id || null,
                            organization_person_id: formData.assigned_employee_id || null,
                            scheduled_date: null,
                            allocated_minutes: 0,
                            is_reassigned: false,
                            task_status: "Pending",
                            status_remarks: "",
                          },
                        ])
                      }
                    >
                      + Add Schedule
                    </Button>
                  )}

                </div>


              </Grid>

              {
                mode != "view" &&
                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  onClick={handleSubmit}
                  disabled={loading || btnLoading}
                  sx={{
                    borderRadius: 2,
                    minWidth: 120,
                    textTransform: "capitalize",
                    fontWeight: 500,
                    mt: 2
                  }}
                >
                  {loading || btnLoading ? (
                    <CircularProgress size={22} sx={{ color: "#fff" }} />
                  ) : mode === "edit" || mode === "edit-v2" ? (
                    "Update"
                  ) : (
                    "Submit"
                  )}
                </Button>
              }

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default InternProjectTasksForm



{/* <TextField
                  fullWidth
                  select
                  disabled={mode == "view"}
                  label="Status "
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  error={!!formErrors.status}
                  helperText={formErrors.status}
                  InputProps={{
                    endAdornment:
                      formData.status && mode !== "view" ? (
                        <InputAdornment position="end" sx={{ mr: "20px" }}>
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleChange({
                                target: {
                                  name: "status",
                                  value: "",
                                },
                              })
                            }
                          >
                            <GridClearIcon fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ) : null,
                  }}
                >
                  {['Pending', 'In Progress', 'In Review', 'Approved', 'Rejected', 'Completed', 'Blocked'].map(status => (
                    <MenuItem key={status} value={status}>{status}</MenuItem>
                  ))}
                </TextField>

                <TextField
                  disabled={mode == "view"}
                  fullWidth
                  label="Status Remarks "
                  name="status_remarks"
                  value={formData.status_remarks}
                  onChange={handleChange}
                /> */}
